<template>
  <div class="login-container">
    <div class="left"></div>
    <div class="right">
      <div class="ykw">账号登录</div>
      <div class="login-form">
        <el-form ref="form" :model="formData" label-width="0" :rules="rules">
          <el-form-item prop="account">
            <el-input v-model="formData.mobile" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input class="yan-input" v-model="formData.code" placeholder="请输入验证码">
              <template slot="append">
                <el-link
                    :type="isDisabled ? 'info' : 'primary'"
                    :disabled="isDisabled"
                    :underline="false"
                    @click="getCode"
                    class="yan_code"
                >
                  {{ codeStr }}
                </el-link>

              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="login-btn">
              <el-button type="primary" @click="onSubmit">登录</el-button>
            </div>
          </el-form-item>
        </el-form>
        <!-- 阿里云图形验证码 -->
        <ali-captcha
          ref="captcha"
          :captcha-id="captchaId"
          @success="onCaptchaSuccess"
          @error="onCaptchaError"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { checkLoginAPI, getLoginCodeAPI } from './api';
import AliCaptcha from '@/components/AliCaptcha/index.vue';

export default {
  name: 'Login',
  components: {
    AliCaptcha
  },

  data() {
    return {
      // 阿里云图形验证码 captchaId
      captchaId: 'c97f715f4a55220c58c30f36e4e79154',
      isDisabled: false,
      imgCode: '',
      formData: {
        code: '',
        mobile: '',
      },
      rules: {},
      codeStr: '获取验证码'
    }
  },

  mounted() {},

  methods: {
    onSubmit() {
      this.$store.dispatch('Login', this.formData).then(() => {
        this.$router.push({ path: '/home' })
        sessionStorage.removeItem('keyPath')
      })
    },
    // 点击「获取验证码」：先弹出图形验证码，验证通过后才发短信
    getCode() {
      if(!this.formData.mobile) return this.$message.error('手机号必填')
      checkLoginAPI(this.formData.mobile)
        .then((res) => {
          this.$refs.captcha && this.$refs.captcha.show();
        });
    },
    // 图形验证码验证通过 → 携带二次校验参数发短信
    async onCaptchaSuccess(result) {
      try {
        await getLoginCodeAPI(this.formData.mobile, result)
        this.isDisabled = true
        let sec = 59
        this.codeStr = `重发（${sec}s）`
        this.timer = setInterval(() => {
          sec = sec - 1
          this.codeStr = `重发（${sec}s）`
          if (sec <= 0) {
            this.codeStr = '获取验证码'
            this.isDisabled = false
            clearInterval(this.timer)
          }
        }, 1000)
      } catch (e) {
        this.$message.error('发送验证码失败，请重试')
      } finally {
        // 后端校验完成后再重置验证码，便于下次重新验证
        this.$refs.captcha && this.$refs.captcha.reset();
      }
    },
    onCaptchaError() {
      this.$message.error('图形验证码校验失败，请重试');
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  align-items: center;
  height: 100vh;

  flex: 1;
  background: url('/bg.jpg') no-repeat;
  background-size: cover;
  background-position: center;

  .left {
    min-width: 500px;
    flex: 1;
  }

  .right {
    width: 534px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-right: 200px;
    background-color: #ffffff;
    padding: 85px 40px;
    border-radius: 16px;
    box-shadow: 0px 2px 6px  rgba(0, 0, 0, 0.15);

    .logo-img {
      display: flex;
      align-items: center;
      margin-bottom: 32px;
      .left-logo {
        margin-right: 12px;
        width: 256px;
        height: 102px;
        img {
          width: 256px;
          margin-left: -40px;
        }
      }
      .right-txt {
        width: 78px;
        height: 24px;
        img {
          width: 78px;
          height: 24px;
        }
      }
    }
    .ykw {
      color: #1a1e25;
      line-height: 32px;
      margin-bottom: 20px;
      text-align: center;
      margin-bottom: 130px;
      font-size: 30px;
    }
    .ykw-en {
      line-height: 32px;
      font-weight: 500;
      font-size: 16px;
      color: #788692;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .login-form {
      .tip-icon {
        display: flex;
        align-items: center;
        line-height: 30px;
        color: #1a1e25;
        font-size: 14px;
        img {
          margin-right: 8px;
        }
      }
      .yzm-img {
        height: 48px;
      }
      .yan-input /deep/{
        .el-input__inner {
          border-right: none;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
          border-top-right-radius: 0!important;
          border-bottom-right-radius: 0!important;
        }
        .el-input-group__append {
          background-color: #fff;
          border-left: none;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
        }
        .yan_code {
          font-size: 16px;
          border-left: 1px solid #ccc;
          padding-left: 20px;
        }
      }
      .el-form /deep/ {
        .el-input__inner {
          height: 48px;
          border-radius: 8px;
        }
        .login-btn {
          display: flex;
          margin-top: 40px;
          .el-button {
            flex: 1;
            height: 48px;
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            background-color: rgba(54, 134, 255, 1);;
            border-color: rgba(54, 134, 255, 1);;
            border-radius: 8px;
          }
        }
        .reset-btn {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 12px;
        }
      }
    }
  }
}
</style>
